export default {
  quotes(state) {
    return state.quotes;
  },
  totalQuotes(state) {
    return state.totalQuotes;
  }
};
